import Model from "./Model";

export default class extends Model {
    async loadTable(page, limit, search = '') {
        let response = await super.list(page, limit, search).then(result => {return result});
        let result = {
            tbody: [],
            pages: response.pages,
        };
        if(response.items !== undefined && response.items.length > 0)
        {
            response.items.forEach(notification => {
                let telem = {
                    tbody: {}
                };
                telem.id = notification.id;
                telem.tbody.name = notification.name;
                result.tbody.push(telem);
            });
        }
        return result;
    }

    async loadNotification(page = 1, limit = 1, search = '') {
        let response = await super.list(page, limit, search).then(result => {return result});
        //console.log(response);
        let result = {
            item: [],
            pages: response.pages,
        };


        if(response.items !== undefined && response.items.length > 0)
        {
            response.items.forEach(notification => {
                let telem = {
                };
                telem.id = notification.id;
                telem.name = notification.name;
                result.item.push(telem);
            });
        }

        return result;
    }

    async readed_notify(url = '', id = 0) {
        return await axios.post(url, {
            id: id
        }).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }
}
